import {
  Button,
  ErrorBox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@gearbox-protocol/deploy-tools-ui";
import { type TaskDefinitionFormSchema, taskDefinitionFormSchema } from "api";
import {
  TaskDefinitionConstructor,
  useTaskDefinitionForm,
} from "components/task-definitions";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { preventSubmitOnEnter } from "utils";

export interface TaskDefinitionFormProps {
  defaultValues: TaskDefinitionFormSchema;
  onSubmit: (data: TaskDefinitionFormSchema) => Promise<void>;
  isNew?: boolean;
  submitButtonText: string;
  title: string;
}

export const TaskDefinitionForm: FC<TaskDefinitionFormProps> = props => {
  const { submitButtonText, onSubmit, defaultValues, title, isNew } = props;
  const { form, error, submit } = useTaskDefinitionForm({
    schema: taskDefinitionFormSchema,
    defaultValues,
    onSubmit,
  });

  const navigate = useNavigate();

  return (
    <Form {...form}>
      <form
        onSubmit={submit}
        onKeyDown={preventSubmitOnEnter}
        className="space-y-2"
      >
        <h2>{title}</h2>

        <FormField
          control={form.control}
          name="id"
          render={({ field }) => (
            <FormItem>
              <FormLabel>ID</FormLabel>
              <FormControl>
                <Input
                  placeholder="Task definition id"
                  {...field}
                  value={field.value ?? ""}
                  disabled={!isNew}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <TaskDefinitionConstructor form={form as any} />
        {!!error && <ErrorBox>{error}</ErrorBox>}

        <Button
          type="submit"
          disabled={form.formState.isSubmitting}
          className="self-start w-64"
          loading={form.formState.isSubmitting}
        >
          {submitButtonText}
        </Button>

        <Button
          type="button"
          variant="secondary"
          className="w-64 ml-2"
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
      </form>
    </Form>
  );
};
